module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iFhaK"))).then(() => parcelRequire('iDabs'));